// @noflow
import { Action, Container, Device, IconWrapper, StyledDeviceIcon, Summary } from './style';

import Dropdown from '~/components/widgets/dropdown/';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import * as React from 'react';

const propTypes = {
    action: PropTypes.string,
    currentIndex: PropTypes.number,
    deviceType: PropTypes.string.isRequired,
    handleSelection: PropTypes.func,
    isDeviceActiveState: PropTypes.bool,
    list: ImmutablePropTypes.list.isRequired
};

const DeviceSelector = ({ action, currentIndex, deviceType, handleSelection, isDeviceActiveState, list }) => (
    <Container>
        <IconWrapper>
            <StyledDeviceIcon active={isDeviceActiveState} type={deviceType} />
        </IconWrapper>
        <Summary>
            {list.size === 1 && <Device>{list.get(currentIndex)}</Device>}
            {list.size > 1 && <Dropdown currentValue={currentIndex} handleChange={handleSelection} options={list} />}
            {action && <Action>{action}</Action>}
        </Summary>
    </Container>
);

DeviceSelector.propTypes = propTypes;

export default DeviceSelector;



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/device-selector/index.js